import { gql } from '@apollo/client';
import {BLOB_FRAGMENT} from 'graphql/document';

export const MESSAGE_FRAGMENT = gql`
  fragment messageFields on Message {
    id
    attachments {
      ...blobFields
    }
    date
    destAddress
    hasAttachment
    key
    read
    senderAddress
    subject
  }
  ${BLOB_FRAGMENT}
`;